var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9406 0.282227C31.9406 2.32523 31.5542 4.3482 30.8031 6.23562C30.0522 8.12322 28.9515 9.83809 27.5641 11.2827C26.1765 12.7274 24.5293 13.8733 22.7164 14.6551C20.9035 15.437 18.9604 15.8394 16.998 15.8394V0.282227H31.9406Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.5571C0 13.5142 0.3865 11.4912 1.13743 9.60376C1.88837 7.71616 2.98903 6.00129 4.37658 4.55664C5.76413 3.11198 7.41138 1.96603 9.22428 1.18421C11.0372 0.402393 12.9803 0 14.9426 0V15.5571H0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.7173C0 30.6743 0.3865 28.6513 1.13743 26.7639C1.88837 24.8763 2.98903 23.1614 4.37658 21.7168C5.76413 20.2722 7.41138 19.1262 9.22428 18.3444C11.0372 17.5626 12.9803 17.1602 14.9426 17.1602V32.7173H0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9406 17.4424C31.9406 19.4854 31.5542 21.5084 30.8031 23.3958C30.0522 25.2834 28.9515 26.9982 27.5641 28.4429C26.1765 29.8875 24.5293 31.0335 22.7164 31.8153C20.9035 32.5971 18.9604 32.9995 16.998 32.9995V17.4424H31.9406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/whiteLogo.b2240a006a1b934741bacbb66be3b8e8.svg";
export { ForwardRef as ReactComponent };